import React from 'react';
import { Link } from 'react-router-dom';
const LinkNovo = ({ to }) => {
    return (
        <Link to={to} className="btn btn-primary">Novo</Link>
    )
};
export default LinkNovo